import {
    useDocsI18n
} from "../i18n";
import type {
    DocsTocItem
} from "../components/toc";
import {
    PageHeader,
    Paragraph,
    CodeBlock,
    Article,
    Callout,
    Section
} from "../components/content";

const INSTALL_CODE = "yarn add ncore-ui-kit react-native-svg react-native-safe-area-context @react-native-clipboard/clipboard";

const SETUP_CODE = `import {
    type NCoreUIKitConfig,
    setupNCoreUIKit
} from "ncore-ui-kit";

const NCoreConfig: NCoreUIKitConfig = {
    initialSelectedGapPropagation: "spacious",
    initialSelectedPalette: "nibgat",
    initialSelectedTheme: "system",
    projectThemes: yourThemeOverrides,
    projectLocales: yourLocales
};

const NCoreUIKitBase = setupNCoreUIKit(NCoreConfig);

const App = () => {
    return <NCoreUIKitBase.Provider>
        <YourNavigation/>
    </NCoreUIKitBase.Provider>;
};`;

const WEBPACK_CODE = `const { withNCoreUIKitWebpack } = require("ncore-ui-kit/webpack-config");

module.exports = withNCoreUIKitWebpack(config, webpack);`;

export const getInstallationToc = (t: (key: string) => string): Array<DocsTocItem> => [
    {
        title: t("install.packageTitle"),
        id: "package"
    },
    {
        title: t("install.setupTitle"),
        id: "setup"
    },
    {
        title: t("install.fontsTitle"),
        id: "fonts"
    },
    {
        title: t("install.webTitle"),
        id: "web"
    }
];

const InstallationPage = () => {
    const {
        t
    } = useDocsI18n();

    return <Article>
        <PageHeader
            breadcrumbs={[
                {
                    label: t("breadcrumb.docs"),
                    href: "/"
                },
                {
                    label: t("page.installation")
                }
            ]}
            title={t("page.installation")}
            lead={t("install.lead")}
        />
        <Section
            title={t("install.packageTitle")}
            id="package"
        >
            <Paragraph>
                {t("install.packageText")}
            </Paragraph>
            <CodeBlock
                code={INSTALL_CODE}
                language="shell"
            />
            <Callout>
                {t("install.calloutText")}
            </Callout>
        </Section>
        <Section
            title={t("install.setupTitle")}
            id="setup"
        >
            <Paragraph>
                {t("install.setupText")}
            </Paragraph>
            <CodeBlock
                code={SETUP_CODE}
                language="tsx"
            />
        </Section>
        <Section
            title={t("install.fontsTitle")}
            id="fonts"
        >
            <Paragraph>
                {t("install.fontsText")}
            </Paragraph>
        </Section>
        <Section
            title={t("install.webTitle")}
            id="web"
        >
            <Paragraph>
                {t("install.webText")}
            </Paragraph>
            <CodeBlock
                code={WEBPACK_CODE}
                language="js"
            />
        </Section>
    </Article>;
};
export default InstallationPage;
